var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callall"
  }, [_c('div', {
    staticClass: "calltop"
  }, [_c('span', {
    staticClass: "callbtn",
    on: {
      "click": function($event) {
        _vm.callcut('cut')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("呼叫")])]), _vm._v(" "), _c('div', {
    staticClass: "callstyle"
  }, [_vm._v("\n    " + _vm._s(_vm.callstyle) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "calltime"
  }, [_vm._v("\n    " + _vm._s(_vm.calltime) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "callnum"
  }, [_vm._v("\n    " + _vm._s(_vm.callnum) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "keyword"
  }, _vm._l((_vm.callkey), function(item, index) {
    return _c('span', {
      class: {
        'mid': (item.key == 2 || item.key == 5 || item.key == 8 || item.key == 0)
      },
      attrs: {
        "keys": index,
        "id": 'cd' + item.key
      },
      on: {
        "touchstart": function($event) {
          _vm.cdown('cd' + item.key)
        },
        "touchend": function($event) {
          _vm.cup('cd' + item.key)
        },
        "click": function($event) {
          _vm.keygo(item.voicePath, item.key, item.action, item.id, item.teamId, item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.key) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "callclose"
  }, [(_vm.callis) ? _c('img', {
    attrs: {
      "src": "/pc/static/assets/callcut.png"
    },
    on: {
      "click": function($event) {
        _vm.callcut('cut')
      }
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/callclose.png"
    },
    on: {
      "click": function($event) {
        _vm.callcut('no')
      }
    }
  })]), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "remoteAudioMedia",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "ding",
      "src": "/pc/static/video/ding.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "linevideo",
      "src": _vm.linevideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "callvideov",
      "src": _vm.callvideosrc,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "waitvideo",
      "src": _vm.waitvideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "errorvideo",
      "src": _vm.errorvideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "quesvideo",
      "src": _vm.quesvideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "noservice",
      "src": _vm.noservicevideo,
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "modevoice",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "robotreplace",
      "src": "/pc/static/video/robotreplace.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "answerwrong",
      "src": "/pc/static/video/answerlwrong.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "robotreplace",
      "src": "/pc/static/video/robotreplace.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "phoneanswer",
      "src": "/pc/static/video/robotreplace.mp3",
      "hidden": "true"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "noanswer",
      "src": "/pc/static/video/noanewer.mp3",
      "hidden": "true"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59fda95c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/callcenter/callcenter.vue
// module id = aSGR
// module chunks = 1